import URL from '../url'
import Request from '../request'

/**
 *@param {*} collectionName
 *
 */
export const createCourseCollectionService = entity =>
  new Request(URL.API, URL.CREATE_COURSE_COLLECTION).post(entity)

/**
 *@param {*} id
 *
 */
export const deleteCourseCollectionService = id =>
  new Request(URL.API, URL.DELETE_COURSE_COLLECTION).delete({ id })

/**
 * @param {*} id
 * @param {*} targetLanguage
 */
export const collectionTranslateService = (id, targetLanguage) =>
  new Request(URL.API, URL.COLLECTION_TRANSLATE.replace('{id}', id)).post({ targetLanguage })

/**
 * Returns the credit cost estimate for translating a collection:
 *   { pageCount, creditsPerPage, totalCredits }
 * @param {*} id
 */
export const collectionTranslationCostEstimateService = id =>
  new Request(
    URL.API,
    URL.COLLECTION_TRANSLATION_COST_ESTIMATE.replace('{id}', id),
  ).get()

/**
 * Duplicates a collection (everything except learners and collaborators).
 * @param {*} id
 */
export const collectionCloneService = id =>
  new Request(URL.API, URL.COLLECTION_CLONE.replace('{id}', id)).post({})

/**
 * @param {*} query
 *
 */
export const listCourseCollectionService = query =>
  new Request(URL.API, URL.LIST_COURSE_COLLECTION).post(query)

/**
 * @param {*} entity
 *
 */
export const updateCourseCollectionService = entity =>
  new Request(URL.API, URL.UPDATE_COURSE_COLLECTION).put(entity)

/**
 *
 * @param {*} content
 */
export const collectionCoursePatchService = content =>
  new Request(URL.API, URL.PATCH_COLLECTION_COURSE + '?id=' + content.id).patch(
    content,
  )

/**
 * @param {*} collectionId
 * @param {*} courseId
 */

export const getCollectionAnalyticsService = (collectionId, courseId) => {
  return new Request(
    URL.API,
    URL.GET_COLLECTION_ANALYTICS.replace('{collectionId}', collectionId),
  ).get({ courseId })
}
